export default [
  {
    id: '8fec597f-c373-4047-80a9-4ec76cfbf08c',
    path: 'data-asset-management',
    name: 'data-asset-management',
    meta: { title: '数据资产管理' },
    children: [
      {
        id: 'bce869e6-25ca-4951-b4d2-d962f7cd246c',
        path: 'data-detail',
        name: 'data-detail',
        component: () => {
          return import('../views/dataAssetManagement/dataDetail')
        },
        meta: {
          title: '实体数据管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '6fc0a8b7-3faa-433a-91d7-1ff6c9f2d54b',
        path: 'ai-intelligent',
        name: 'ai-intelligent',
        component: () => {
          return import('../views/dataAssetManagement/aiIntelligent')
        },
        meta: {
          title: 'AI智能问答',
          keepAlive: false,
        },
      },
      {
        id: '5feb14f5-e667-4c09-a2fa-45de715c42de',
        path: 'master-data-management',
        name: 'master-data-management',
        component: () => {
          return import('../views/dataAssetManagement/MasterDataManagement')
        },
        meta: {
          title: '主数据管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: 'bf2ab7b5-aa6a-4016-b495-bcf0223b0ce5',
        path: 'data-retrieval',
        name: 'data-retrieval',
        component: () => {
          return import('../views/dataAssetManagement/dataRetrieval')
        },
        meta: {
          title: '数据资产检索',
          keepAlive: true,
        },
      },
      {
        id: '5631cd52-d60e-4adb-8a01-8a329618e901',
        path: 'data-retrieval-detail',
        name: 'data-retrieval-detail',
        component: () => {
          return import('../views/dataAssetManagement/dataRetrievalDetail')
        },
        meta: { title: '数据检索详情', hidden: true },
      },
      {
        id: '018c8837-de3f-4425-90d8-302225ccd8c6',
        path: 'data-label-management',
        name: 'data-label-management',
        component: () => {
          return import('../views/dataAssetManagement/dataLabelManagement')
        },
        meta: {
          title: '数据资产标签',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            dataLabel: {
              id: 3,
              name: 'dataLabel',
              desc: '数据标签',
              access: true,
            },
          },
        },
      },
      {
        id: '53b1757e-21d9-401f-9e05-92c074e5f82b',
        path: 'data-label-detail',
        name: 'data-label-detail',
        component: () => {
          return import('../views/dataAssetManagement/dataLabelDetail')
        },
        meta: {
          title: '数据标签管理',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-asset-management/data-label-management',
        },
      },
      {
        id: 'd1ae47ee-0439-4b69-a855-4c9a53bf863f',
        path: 'asset-catalogue',
        name: 'asset-catalogue',
        component: () => {
          return import('../views/dataAssetManagement/assetCatalogue')
        },
        meta: {
          title: '数据资产目录',
          keepAlive: false,
          operations: {
            collect: {
              id: 0,
              name: 'collect',
              desc: '收藏',
              access: true,
            },
            unbookmark: {
              id: 1,
              name: 'unbookmark',
              desc: '取消收藏',
              access: true,
            },
          },
        },
      },
      {
        id: '43bfbdd3-fb39-4834-b7ed-393a968ce8b5',
        path: 'asset-view',
        name: 'asset-view',
        component: () => {
          return import('../views/dataAssetManagement/assetView')
        },
        meta: { title: '资产查看', hidden: true },
      },
      {
        id: '0c171fc8-0b22-4f76-8283-b80f3970838d',
        path: 'entity-collection',
        name: 'entity-collection',
        component: () => {
          return import('../views/dataAssetManagement/entityCollection')
        },
        meta: {
          title: '实体关联管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            save: {
              id: 1,
              name: 'save',
              desc: '保存',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: 'b63e6681-d254-486a-9d13-b56f759d0c84',
        path: 'asset-configure',
        name: 'asset-configure',
        component: () => {
          return import('../views/dataAssetManagement/assetConfigure')
        },
        meta: {
          title: '资产目录配置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            save: {
              id: 1,
              name: 'save',
              desc: '保存',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            add: {
              id: 3,
              name: 'add',
              desc: '添加层级',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: 'a234216b-ce6e-4694-8ee5-a6a90fb71e27',
        path: 'theme-managerment',
        name: 'theme-managerment',
        component: () => {
          return import('../views/dataAssetManagement/themeManagerment')
        },
        meta: {
          title: '主题管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '38a703c4-8dd1-46b6-b194-8a05fbc65691',
        path: 'operations-management',
        name: 'operations-management',
        component: () => {
          return import('../views/dataAssetManagement/operationsManagement')
        },
        meta: {
          title: '业务操作管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '3d695472-e5ab-4317-ba69-f13e65ebb5cd',
        path: 'attr-operation-config',
        name: 'attr-operation-config',
        component: () => {
          return import('../views/dataAssetManagement/attrOperationConfig')
        },
        meta: {
          title: '属性业务操作配置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: 'cb09497f-6c6f-4968-810b-3707ca6bf504',
        path: 'point',
        name: 'point',
        component: () => {
          return import('../views/dataAssetManagement/point')
        },
        meta: {
          title: '测点清单',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '0e3da485-1647-4eb0-ae60-6ed5e73ac2b6',
        path: 'point-search',
        name: 'point-search',
        component: () => {
          return import('../views/dataAssetManagement/pointSearch')
        },
        meta: {
          title: '测点查询',
          keepAlive: false,
          operations: {
            export: {
              id: 0,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '趋势曲线',
              access: true,
            },
          },
        },
      },
      {
        id: 'b7900cf7-b2e4-426b-a5cf-bf32111463d6',
        path: 'change-log',
        name: 'change-log',
        component: () => {
          return import('../views/dataAssetManagement/changeLog')
        },
        meta: {
          title: '变更记录',
          keepAlive: false,
          operations: {
            export: {
              id: 0,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
    ],
  },
]
